import { Modal } from "bootstrap";
import React, { createRef, useEffect, useState } from "react";
import { usePromos } from "../context/promos";
import AvatarGroup from 'react-avatar-group';
// import addImage from '../assets/add_image.jpg'
import { isEmail } from "../utils/validators";

const nuevaPromo = {
    name: '',
    code: '',
    img: '/assets/leclab-madrid-vertical.png',
    users: [],
    type: ""
}

export const PromoModal = React.forwardRef(({ data, hideModal }, ref) => {

    const [loading, setLoading] = useState(false)
    const [promo, setPromo] = useState(nuevaPromo)
    const [email, setEmail] = useState('')
    const { createPromo, updatePromo } = usePromos()

    const handleImageChange = (value) => {
        // var imageFile = URL.createObjectURL(e.target.files[0])
        // setPromo({ ...promo, img: imageFile })
        if (value === "Leclab Royal") {
            setPromo({ ...promo, img: "/assets/promo_leclab_royal.jpg", type: value })
        }
        else if (value === "Lunes de Leclab") {
            setPromo({ ...promo, img: "/assets/promo_lunes_leclab.jpg", type: value })
        }
        else if (value === "Taller") {
            setPromo({ ...promo, img: "/assets/promo_taller.jpg", type: value })
        }
        else if (value === "Fiesta Leclab") {
            setPromo({ ...promo, img: "/assets/promo_fiesta_leclab.jpg", type: value })
        }
        else {
            setPromo({ ...promo, img: "/assets/leclab-madrid-vertical.png", type: value })
        }
    }

    const handleInputChange = (e) => {
        var name = e.target.name
        var value = e.target.value
        setPromo({ ...promo, [name]: value })
    }

    const addEmail = (e) => {
        e.preventDefault()
        if (e.which === 13) {
            const email = e.target.value
            if (isEmail(email)) {
                setPromo({ ...promo, users: [...promo.users, email] })
                setEmail('')
            }
        }
    }

    const removeEmail = (email) => {
        const newEmails = promo.users.filter(uemail => uemail !== email)
        setPromo({ ...promo, users: newEmails })
    }

    const doSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        if (promo.id) {
            updatePromo(promo).then(() => {
                setLoading(false)
            })
        }
        else {
            createPromo(promo).then(() => {
                setLoading(false)
            })
        }
        hideModal()
        setPromo(nuevaPromo)
    }

    useEffect(() => {
        if (!data) return
        setPromo(data)
    }, [])

    return (
        <div className="modal fade" ref={ref} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{data ? 'Editar promoción' : 'Nueva promoción'}</h5>
                        <button type="button" id="close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setPromo(nuevaPromo)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="container d-flex flex-column justify-content-around align-items-center">
                            <div className="crop">
                                <img src={promo.img} className="img-responsive img-thumbnail mb-4" alt="..." />
                            </div>
                            <div className="row text-start">
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Tipo de evento</label>
                                    <select type="text" className="form-select" value={promo.type} onChange={e => handleImageChange(e.target.value)}>
                                        <option value="">--</option>
                                        <option value="Leclab Royal">Leclab Royal</option>
                                        <option value="Lunes de Leclab">Lunes de Leclab</option>
                                        <option value="Taller">Taller</option>
                                        <option value="Fiesta Leclab">Fiesta Leclab</option>
                                    </select>
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Nombre de la promoción</label>
                                    <input type="text" className="form-control" name='name' value={promo.name} onChange={handleInputChange} />
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Código</label>
                                    <input type="text" className="form-control" name='code' value={promo.code} onChange={handleInputChange} />
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Usuarios</label>
                                    <input type="text" className="form-control mb-2" value={email} onChange={e => setEmail(e.target.value)} onKeyUp={addEmail} />
                                    {promo?.users.map((email, index) => (
                                        <div key={`email-${index}`} className="chip">
                                            {email}
                                            <i className="fa fa-times" onClick={() => removeEmail(email)} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-dark" onClick={doSubmit}>{loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Guardar'}</button>
                    </div>
                </div>
            </div>
        </div>
    )
});

const Promo = ({ data: promo }) => {
    const { deletePromo } = usePromos()
    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: 'static',
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
        // refresh()
    }

    const doDelete = (e) => {
        e.preventDefault()
        if (window.confirm('¿Está seguro de que desea eliminar esta promoción?')) deletePromo(promo.id)
        return
    }

    return (
        <tr>
            <td valign="middle">
                <img width={150} src={promo.img} />
            </td>
            <td valign="middle">{promo.name}</td>
            <td valign="middle">{promo.code}</td>
            <td valign="middle">
                {promo.users < 1 ? 'Todos'
                    :
                    <AvatarGroup
                        avatars={promo.users}
                        initialCharacters={1}
                        max={3}
                        size={40}
                        displayAllOnHover
                        shadow={2}
                    />
                }

            </td>
            <td valign="middle">
                <div>
                    <button className="btn btn-sm btn-outline-success me-1"
                        onClick={showModal}>
                        <i className="fa fa-pencil" style={{ fontSize: '18px' }} />
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={doDelete}>
                        <i className="fa fa-trash" style={{ fontSize: '18px' }} />
                    </button>
                    <PromoModal data={promo} hideModal={hideModal} ref={modalRef} />
                </div>
            </td>
        </tr>
    )
}

export default Promo;